import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/scroll-to-top';

import HomePage from './pages/index';
import AboutPage from './pages/about';
import AgenciesPage from './pages/agencies';
import CareersPage from './pages/careers';
import ContactPage from './pages/contact';
import FaqPage from './pages/faq';
import HowItWorksPage from './pages/how-it-works';
import PricingPage from './pages/pricing';
import PrivacyPolicyPage from './pages/privacy-policy';
import TermsOfServicePage from './pages/terms-of-service';
import TermsOfServiceAnnualPage from './pages/terms-of-service-annual';
import TermsOfServiceUnlimitedPage from './pages/terms-of-service-unlimited';
import TermsOfUsePage from './pages/terms-of-use';
import UseCasesPage from './pages/use-cases';
import NotFoundPage from './pages/404';
import CanopyGrowthPage from './pages/case-study/canopy-growth';
import MarchNetworksPage from './pages/case-study/march-networks';
import WesleyCloverPage from './pages/case-study/wesley-clover';

const App: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/agencies" element={<AgenciesPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route
          path="/terms-of-service-annual"
          element={<TermsOfServiceAnnualPage />}
        />
        <Route
          path="/terms-of-service-unlimited"
          element={<TermsOfServiceUnlimitedPage />}
        />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/use-cases" element={<UseCasesPage />} />
        <Route
          path="/case-study/canopy-growth"
          element={<CanopyGrowthPage />}
        />
        <Route
          path="/case-study/march-networks"
          element={<MarchNetworksPage />}
        />
        <Route
          path="/case-study/wesley-clover"
          element={<WesleyCloverPage />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;
